// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "booking_funnel".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "booking_funnel" table (1:1 with a DB row, on the wire). */
export const bookingFunnelAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    serviceId: z.string().nullable(),
    packageId: z.string().nullable(),
    offerId: z.string().nullable(),
    sourceMetaAdId: z.string().nullable(),
    copy: z.unknown().nullable(),
    copyGeneratedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=bookingFunnel.js.map